import React, { useState, useEffect } from "react";
import { Modal, Collapse, Table, Checkbox, Space, Button } from "antd";
import { Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const { Panel } = Collapse;

const ProfitTableModal = ({
  isModalVisible,
  selectedBienKiemSoat,
  chartData,
  chartDtData,
  modalData,
  showDetails,
  setShowDetails,
  modalColumns,
  onClose,
}) => {

  // Trạng thái cột được chọn (hiển thị ban đầu tất cả các cột)
  const [selectedColumns, setSelectedColumns] = useState(modalColumns.map((col) => col.key));

  const [visibleColumns, setVisibleColumns] = useState(modalColumns.map((col) => col.key));

  useEffect(() => {
    setVisibleColumns(modalColumns.filter((col) => selectedColumns.includes(col.key)));
  }, [selectedColumns]);

  const [tempSelectedColumns, setTempSelectedColumns] = useState(selectedColumns); // Tạm lưu cột khi chỉnh sửa

  const handleSelectAll = () => {
    setTempSelectedColumns(modalColumns.map((col) => col.key)); // Chọn tất cả các cột
  };

  const handleDeselectAll = () => {
    setTempSelectedColumns([]); // Bỏ chọn tất cả các cột
  };

  const handleConfirmSelection = () => {
    setSelectedColumns(tempSelectedColumns); // Xác nhận cột đã chọn
  };

  const handleCancelSelection = () => {
    setTempSelectedColumns(selectedColumns); // Khôi phục lại trạng thái ban đầu
  };

  return (
    <Modal
      title={`Chi tiết các chuyến của xe: ${selectedBienKiemSoat}`}
      visible={isModalVisible}
      onCancel={onClose}
      footer={null}
      width="80%"
    >
      {chartData && (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "20px" }}>
          {/* Biểu đồ 1: Phân bổ chi phí */}
          <div style={{ width: "42%" }}>
            <h3 style={{ textAlign: "center" }}>Phân bổ chi phí</h3>
            <Pie
              data={chartData}
              options={{
                plugins: {
                  legend: {
                    position: "right",
                    labels: {
                      generateLabels: function (chart) {
                        const dataset = chart.data.datasets[0];
                        const total = dataset.data.reduce((sum, value) => sum + value, 0);

                        return chart.data.labels.map((label, i) => {
                          const value = dataset.data[i];
                          const percentage = ((value / total) * 100).toFixed(2);
                          return {
                            text: `${label}: ${value} (${percentage}%)`,
                            fillStyle: dataset.backgroundColor[i],
                            strokeStyle: dataset.borderColor ? dataset.borderColor[i] : dataset.backgroundColor[i],
                            hidden: chart.getDatasetMeta(0).data[i].hidden,
                            index: i,
                          };
                        });
                      },
                    },
                  },
                  tooltip: {
                    callbacks: {
                      label: function (tooltipItem) {
                        const dataset = tooltipItem.dataset;
                        const total = dataset.data.reduce((sum, value) => sum + value, 0);
                        const currentValue = dataset.data[tooltipItem.dataIndex];
                        const percentage = ((currentValue / total) * 100).toFixed(2);
                        return `${tooltipItem.label}: ${currentValue} (${percentage}%)`;
                      },
                    },
                  },
                },
              }}
            />
          </div>

          {/* Biểu đồ 2: Phân bổ doanh thu */}
          <div style={{ width: "42%" }}>
            <h3 style={{ textAlign: "center" }}>Phân bổ doanh thu</h3>
            <Pie
              data={chartDtData}
              options={{
                plugins: {
                  legend: {
                    position: "right",
                    labels: {
                      generateLabels: function (chart) {
                        const dataset = chart.data.datasets[0];
                        const total = dataset.data.reduce((sum, value) => sum + value, 0);

                        return chart.data.labels.map((label, i) => {
                          const value = dataset.data[i];
                          const percentage = ((value / total) * 100).toFixed(2);
                          return {
                            text: `${label}: ${value} (${percentage}%)`,
                            fillStyle: dataset.backgroundColor[i],
                            strokeStyle: dataset.borderColor ? dataset.borderColor[i] : dataset.backgroundColor[i],
                            hidden: chart.getDatasetMeta(0).data[i].hidden,
                            index: i,
                          };
                        });
                      },
                    },
                  },
                  tooltip: {
                    callbacks: {
                      label: function (tooltipItem) {
                        const dataset = tooltipItem.dataset;
                        const total = dataset.data.reduce((sum, value) => sum + value, 0);
                        const currentValue = dataset.data[tooltipItem.dataIndex];
                        const percentage = ((currentValue / total) * 100).toFixed(2);
                        return `${tooltipItem.label}: ${currentValue} (${percentage}%)`;
                      },
                    },
                  },
                },
              }}
            />
          </div>
        </div>
      )}
      {showDetails && (
        <div>
          {/* Tùy chọn cột */}
          <Collapse style={{ marginBottom: "20px" }}>
            <Panel header="Tùy chọn cột hiển thị" key="1">
              <Space direction="vertical" style={{ display: "flex" }}>
                <Checkbox.Group
                  options={modalColumns.map((col) => ({ label: col.title, value: col.key }))}
                  value={tempSelectedColumns}
                  onChange={setTempSelectedColumns}
                />
                <Space>
                  <Button type="primary" onClick={handleSelectAll}>
                    Chọn tất cả
                  </Button>
                  <Button onClick={handleDeselectAll}>Bỏ chọn tất cả</Button>
                  <Button type="primary" onClick={handleConfirmSelection}>
                    Xác nhận
                  </Button>
                  <Button onClick={handleCancelSelection}>Hủy</Button>
                </Space>
              </Space>
            </Panel>
          </Collapse>
          {/* Bảng */}
          <Table
            dataSource={modalData}
            columns={visibleColumns}
            rowKey="ma_chuyen"
            scroll={{ x: "max-content" }}
            bordered
          />
        </div>
      )}
      <Button onClick={() => setShowDetails(!showDetails)}>{showDetails ? "Ẩn chi tiết" : "Xem chi tiết"}</Button>
    </Modal>
  );
};

export default ProfitTableModal;
